import type { ComponentProps } from 'react';
import { useTranslation } from '@/shared/i18n/use-translation';
import { TextField } from './text-field';

type TagsFieldProps = Omit<ComponentProps<typeof TextField>, 'type' | 'inputMode'>;

/** Comma-separated tags (parse with parseTags). */
export function TagsField(props: TagsFieldProps) {
  const { t } = useTranslation();
  return <TextField placeholder={t('backpack, car, winter')} hint={t('Separated by commas')} {...props} />;
}
